import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';

import { Handle, Position } from 'reactflow';
import { DialogWaterLevel } from 'src/modules/mizusaki/components/DialogWaterLevel.component';

export const GraphNode = ({ data }: { data: any }) => {

    const dataDialog = useSelector((state: RootState) => state.showDialogReducer.position);
    const currentDeviceId = dataDialog?.deviceId;

    return (currentDeviceId ? (
        <div style={{ width: '600px', minHeight: '400px' }}>
            <div className="p-4">
                <DialogWaterLevel />
            </div>
        </div>
    ) : (
        <div className="bg-white border-2 border-gray-300 rounded-lg shadow-lg" style={{ width: '600px', minHeight: '400px' }}>
            <div className="bg-gray-200 text-gray-600 p-2 rounded-t-lg">
                <h3 className="font-bold text-center">グラフ表示パネル</h3>
            </div>
            <div className="p-4">
                <p className="text-center">デバイスが選択されていません</p>
            </div>
        </div>
    )
    );
};